import React, { useState, useRef, useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import { styled } from '@mui/material/styles';
import Modal from "@mui/material/Modal";
import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { publish } from "./events";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import RightIcon from "./Assets/Images/right.svg";
import LeftIcon from "./Assets/Images/left.svg";
import CompletedIcon from "./Assets/Images/completed.svg";
import Tick from "./Assets/Images/tick.svg";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemButton,
  Autocomplete,
  CircularProgress,
  IconButton,
  ListItem,
} from "@mui/material";
import { toast } from "react-toastify";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import { CountryISOCodes } from "./utils/CountryISOCodes";
import getTenantIdFromURL from "./utils/getTenantIdFromURL";
import { useSelector } from "react-redux";
import Fab from '@mui/material/Fab';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { FormGroup, FormControlLabel, FormLabel } from '@mui/material';
import Close from "./Assets/Images/close.svg"
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import PropTypes from 'prop-types';
import { useAddCompanyModal } from "./context/addCompanyModalContext";
import { useLocation } from "react-router-dom";
import { useSegment } from './context/segmentContext';
import { useRecentlyAddedCompanies } from "./context/recentlyAddedCompaniesContext";
import { createCompanyCreationGate, getConfirmedCompanyReceipt } from './utils/companyCreationReceipt';

import companyApi, { 
  createCompanyFromPlatform, 
  searchCompanyOpenAI, 
  searchCompanyPerplexity,
  searchCompanyDnB,
  getCompanyByName,
  searchCompaniesAdvanced,
  updateCompany
} from './api/companyApi';

const CustomCheckbox = styled(Checkbox) ({
  '&.Mui-checked': {
    color: '#5186EC',
  },
  '& .MuiSvgIcon-root': {
    borderRadius: "4px",
    width: "15px"
  },
});

// const trackingID = "G-ZMLGBZEFPF";
// const adminTrackingId = "G-VYW7DRSVZE";



function CreateCompanyModal(props) {
  const { isVerifyEntity = false, handleDelete, companyUniqueID = "", onClose, initialSearchTerm = "", initialCountry = "", companyTree = false } = props;
  // const { isVerifyEntity = false, handleDelete, companyUniqueID = "", onClose, onDunsIdSelect, initialSearchTerm = "", initialCountry = "", companyTree = false } = props;
  const [companyNameValue, setCompanyNameValue] = useState(initialSearchTerm);
  const [requestedCreditLimit, setRequestedCreditLimit] = useState("");
  const [companyDnbId, setCompanyDnbId] = useState("");
  const [companySearchResults, setCompanySearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(false);
  const [errorTxt, setErrorTxt] = useState("This field is required");
  const [open, setOpen] = React.useState(false);
  const [isAddCompanyManuallyModelOpen, setIsAddCompanyManuallyModelOpen] = useState(false);
  const [dnbJsonData, setDnbJsonData] = useState([]);
  const [isPublic, setIsPublic] = useState(false);
  // const [tickerValue, setTickerValue] = useState("");
  const [tickerValue] = useState("");
  const location = useLocation();
  const [ticker, setTicker] = useState("");

  // State Variable used to Filter Search Result
  const [companyCountryValue, setCompanyCountryValue] = useState(initialCountry);
  const [companyStateValue, setCompanyStateValue] = useState("");
  const [companyStreetValue, setCompanyStreetValue] = useState("");
  const [companyZipCode, setCompanyZipCode] = useState("");
  const [currentTenant] = useState(null);
  // const [currentTenant, setCurrentTenant] = useState(null);
  

  //Parent company values
  const [parentCompanyName, setParentCompanyName] = useState("");
  const [parentCompanyCountry, setParentCompanyCountry] = useState("");
  const [parentCompanyDailog, setParentCompanyDailog] = useState(false);
  const [addParentConpany, setAddParentCompany] = useState(false);
  const [showParentCompanySearchResultsDialog, setShowParentCompanySearchResultsDialog] = useState(false);
  const [parentCompanySearchResults, setParentCompanySearchResults] = useState([]);
  const [parentSelectedCompany, setParentSelectedCompany] = useState("");
  const [addCompanyWithoutParent, setAddCompanyWithoutParent] = useState(true);
  // const [isParentCompanyPublic, setIsParentCompanyPublic] = useState(false);
  //const [addCompanyWithoutParent, setAddCompanyWithoutParent] = useState(true);

  const [companyRegistrationNumber, setCompanyRegistrationNumber] = useState("");
  const [countryISOCode, setCountryISOCode] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [searchOption, setSearchOption] = useState(null);
  const [tenantId, setTenantId] = useState()
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const isAdmin = useSelector(state => state.userInfo.isAdmin);
  const URLTenant = getTenantIdFromURL();
  const currentTenantId = useSelector(state => state.userInfo.tenantId);

  const selectTenantId = useCallback(() => {
    if (isAdmin) setTenantId(URLTenant)
    else setTenantId(currentTenantId)
  }, [isAdmin, URLTenant, currentTenantId]);
  // const fileInputRef = useRef(null);

  const tickerValueLength = ticker.length === 0;
  const isSearchDisabledBasedOnTicker = isPublic ? tickerValueLength : false;

  // initialize react google analytics tracking id based on role of user

  //stepper-changes
  const [activeStep, setActiveStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [completed, setCompleted] = useState(false);
  const [showLeftButton, setShowLeftButton] = useState(false);
  const { openAddCompanyModal, setOpenAddCompanyModal } = useAddCompanyModal();
  const [creditLimits, setCreditLimits] = useState({});
  const [perplexityResponse, setPerplexityResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddingCompany, setIsAddingCompany] = useState(false);
  const [isParentCompanyPublic, setIsParentCompanyPublic] = useState(false);
  const [parentCompanyTicker, setParentCompanyTicker] = useState("");

  // Segment-related state
  const { selectedSegment, setSelectedSegment, segments } = useSegment();
  const currentSelectedSegment = useRef(selectedSegment);
  currentSelectedSegment.current = selectedSegment;
  const { addRecentlyAddedCompany } = useRecentlyAddedCompanies();
  const [addMode, setAddMode] = useState(null);
  const [showSegmentDialog, setShowSegmentDialog] = useState(false);
  const [selectedSegmentForCompany, setSelectedSegmentForCompany] = useState(null);
  const [skipSegmentSelection, setSkipSegmentSelection] = useState(false);

  const creationGate = useRef(createCompanyCreationGate());
  const creationMounted = useRef(true);
  const creationScope = useRef('');
  // Resolve from current routing/user state, rather than the tenant state effect,
  // so a late save cannot update a newly selected account's modal.
  const creationTenantId = isAdmin ? URLTenant : currentTenantId;
  const currentCreationScope = `${creationTenantId}:${location.key || ''}:${location.pathname}:${location.search}`;
  creationScope.current = currentCreationScope;
  useEffect(() => {
    creationMounted.current = true;
    return () => { creationMounted.current = false; };
  }, []);
  useEffect(() => {
    setIsAddingCompany(false);
    setDisabled(false);
  }, [currentCreationScope]);
  const isCurrentCreation = (request) => creationMounted.current && creationGate.current.isCurrent(request, creationScope.current);
  const beginCompanyCreation = () => {
    const request = creationGate.current.begin(creationScope.current);
    if (request) {
      request.tenantId = creationTenantId;
      setIsAddingCompany(true);
    }
    return request;
  };
  const finishCompanyCreation = (request) => {
    if (isCurrentCreation(request)) {
      setIsAddingCompany(false);
      setDisabled(false);
    }
    creationGate.current.finish(request);
  };
  const recordCreatedCompany = (response, submitted, request) => {
    const submittedSegment = [selectedSegment, selectedSegmentForCompany]
      .find(segment => segment?.id && segment.id === submitted.segmentID);
    const receipt = getConfirmedCompanyReceipt(response, submitted, submittedSegment);
    addRecentlyAddedCompany(receipt);
    // The summary can arrive before the segment list refreshes. Retain the
    // confirmed membership so replacing the receipt does not hide this row.
    const activeSegment = currentSelectedSegment.current;
    if (isCurrentCreation(request) && submitted.segmentID && activeSegment?.id === submitted.segmentID && typeof setSelectedSegment === 'function') {
      const members = activeSegment.companies?.items || [];
      if (!members.some(company => (company.id || company.companyId) === receipt.companyId)) {
        setSelectedSegment({
          ...activeSegment,
          companies: {
            ...activeSegment.companies,
            items: [...members, { id: receipt.companyId, name: receipt.companyName }],
          },
        });
      }
    }
    return receipt;
  };

  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#2F3D63"
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#2F3D63"
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 0,
      border: '1px solid #2F3D63',
      backgroundColor: "#2F3D63",
      borderRadius: 1,
    },
  }));

  const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : "#E9E9E9",
    zIndex: 1,
    color: '#fff',
    width: 45,
    height: 45,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 3px 6px #00000029',
    ...(ownerState.active && {
      backgroundColor: "#2F3D63",
      boxShadow: '0px 3px 6px #00000029',
      border: "2px solid #5186EC",
    }),
    ...(ownerState.completed && {
      backgroundColor: "#2F3D63",
      boxShadow: '0px 3px 6px #00000029',
    }),
  }));

  function ColorlibStepIcon(props) {
    const { active, completed, className, icon } = props;

    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {completed ? (
          <img src={Tick} width={25} alt="" />
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span style={{ color: active ? "#fff" : '#777A82', fontSize: "18px", fontWeight: "500" }}>{icon}</span>
          </div>
        )}
      </ColorlibStepIconRoot>
    );
  }

  ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
  };

  useEffect(() => {
    selectTenantId();
  }, [tenantId, isAdmin, URLTenant, currentTenantId, selectTenantId]);

  const listRef = useRef(null);
  const initialSearchPerformed = useRef(false);

  const handleScroll = useCallback(() => {
    if (listRef.current) {
      const newScrollLeft = listRef.current.scrollLeft;
      setShowLeftButton(newScrollLeft > 0);
    }
  }, []);

  const scrollListLeft = useCallback(() => {
    if (listRef.current) {
      const scrollAmount = 705;
      const newScrollLeft = Math.max(0, listRef.current.scrollLeft - scrollAmount);
      listRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth',
      });

      listRef.current.addEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  const scrollListRight = useCallback(() => {
    if (listRef.current) {
      const scrollAmount = 705;
      listRef.current.scrollTo({
        left: listRef.current.scrollLeft + scrollAmount,
        behavior: 'smooth',
      });
      listRef.current.addEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  useEffect(() => {
    const currentListRef = listRef.current;
    return () => {
      if (currentListRef) {
        currentListRef.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => {
      switch (prevActiveStep + 1) {
        case 2:
          setCompanyRegistrationNumber("")
          setCompanyNameValue("")
          setTicker("")
          setCountryISOCode("")
          setShowLeftButton(false);
          break;
        case 3:
          setSelectedOption(null)
          setSelectedCompanies([]);
          setDisabled(false)
          setShowLeftButton(false);
          break;
        case 4:

          break;
        default:
          break;
      }
      setDisabled(false);
      return prevActiveStep - 1;
    });
  };


  /*const handleContinue = () => {
    setActiveStep((prevActiveStep) => {
      if ((prevActiveStep + 1) <= steps.length - 1) return prevActiveStep + 1;
      else return prevActiveStep
    });
  };*/
  const handleChange = (value) => {
    setSelectedOption(value);
  };
  const steps = ["one", "two", "three", "four"]

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "833px",
    bgcolor: "background.paper",
    borderRadius: "20px",
    boxShadow: "inset 0px 1px 3px #0000001A, 0px 3px 6px #00000029",
  };
  const formControlLabelStyle = {
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
    },
    margin: "0px"
  }
  const inputStyle = {
    width: "285px",
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      height: '48px',
    },
    "& .MuiOutlinedInput-input": {
      borderRadius: '8px',
      height: '12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
    },
    marginTop: "10px"
  }
  const questionInputStyle = {
    width: "285px",
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      height: '48px',
    },
    "& .MuiOutlinedInput-input": {
      borderRadius: '8px',
      height: '12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
    },
    marginBottom: "15px"
  }

  /*const stepStyle = {
    "& .MuiStepLabel-root": {
      color: "#2F3D63"
    },
    "& .Mui-completed": {
      color: "#2F3D63"
    },
    "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
      color: "#fff"
    },
    "& .MuiStepLabel-root .Mui-active": {
      color: "#2F3D63"
    },
    "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
      color: "#fff"
    },
    "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
      fill: "#fff"
    },
    "& .MuiStepConnector-root": {
      backgroundColor: "#2F3D63", height: "1px"
    },
    "& .MuiStepConnector-line": {
      backgroundColor: "#2F3D63", height: "1px"
    },
  };
*/

  const modalStyle = {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgb(255, 255, 255, 0.5)"
  }

  const stepperStyle = {
    background: "#5186EC1A",
    height: "82px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }

  const fabStyle = {
    margin: 0,
    width: "45px",
    height: "45px",
    backgroundColor: "#5186EC"
  }

  const containerStyle = {
    width: "325px",
    height: "100%",
    display: "flex",
    boxSizing: "border-box",
    padding: "20px",
    flexDirection: "column",
    // alignItems:"center",
    position: "relative",
    justifyContent: "space-around",
  }
  const companyListStyle = {
    //  height:"263px",
    minWidth: "225px",
    maxWidth: "225px",
    border: "1px solid #E9E9E9",
    boxShadow: "0px 1px 3px #00000029",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center"
    // margin:"5px",
  }
  const dropdownStyle = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
      },
    },
    "& .MuiAutocomplete-listbox": {
      fontSize: "0.875rem",
      padding: "0.5rem",
      backgroundColor: "#f5f5f5",
    },
  }
  const backStyle = {
    width: "138px",
    height: "36px",
    border: "1px solid #5186EC",
    borderRadius: "8px",



  }
  const questionStyle = {
    textAlign: "left",
    fontSize: "14px",
    letterSpacing: "0px",
    color: "#2F3D63",
    alignItems: "flex-start",

  }
  const searchStyle = {
    width: "138px",
    height: "36px",
    marginLeft: "10px",
    borderRadius: "8px",
    backgroundColor: "#5186EC",
    '&:disabled': {
      backgroundColor: '#f0f0f0', // Set the color for the disabled state
    },
    '&:hover': {
      backgroundColor: '#5186EC', // Same color on hover
    },
  }

  const buttonsStyle = {
    height: "250px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px"
  }
  const buttonStyle = {
    width: "132px",
    height: "44px",
    borderRadius: "8px",
    backgroundColor: "#5186EC",
  }
  const handleForward = () => {
    setActiveStep((prevActiveStep) => {
      setError(false)
      if ((prevActiveStep + 1) <= steps.length - 1) return prevActiveStep + 1;
      else return prevActiveStep;
    });

  }

  const handleAddAnotherCompany = () => {
    handleClose();
    setActiveStep(0);
  }

  const handleAddClick = async () => {
    const requestScope = creationScope.current;
    if (selectedCompanies.length === 0) {
      setError(true);
      setErrorTxt("Please select at least one company");
      return;
    }
    setDisabled(true);

    try {
      for (let selectedCompany of selectedCompanies) {
        await handleAddCompanyClick(selectedCompany);
        if (!creationMounted.current || creationScope.current !== requestScope) return;
      }

      // Clean up state
      setParentSelectedCompany(null);
      setParentCompanyName(null);
      setParentCompanyCountry(null);
      setSelectedCompanies([]);
      setDisabled(false);
    } catch (error) {
      if (!creationMounted.current || creationScope.current !== requestScope) return;
      console.error("Error adding company:", error);
      toast.error(error.message || "Failed to add company. Please try again.");
      setDisabled(false);
    }
  };

  const handleAddCompanyClick = async (selectedCompany) => {
    const request = beginCompanyCreation();
    if (!request) return;
    try {
      const companyName = initialSearchTerm ? initialSearchTerm : selectedCompany.organization ? selectedCompany.organization.primaryName : selectedCompany?.primary_name.data;
      const companyDuns = selectedCompany.organization ? selectedCompany.organization.duns : null;
      const companyCountry = selectedCompany.organization ? selectedCompany.organization.primaryAddress?.addressCountry?.name : companyCountryValue || "";
      console.log("🚀 ~ companyCountry:", companyCountry)
      const companyTicker = selectedCompany.organization ? selectedCompany.organization.tickerSymbol : ticker || "";
      const companyAddress = selectedCompany.organization?.primaryAddress?.addressCountry?.name || "";
      const companyId = companyDuns || selectedCompany.uniqueId;
      const dunsControlStatus = selectedCompany.organization?.dunsControlStatus || null; 
      const dnbWebsite = selectedCompany?.organization?.domain || null; 
      if (!request.tenantId) {
        throw new Error('TenantId is required but was null');
      }
        // Create new company
      const createData = {
        tenantId: request.tenantId,
        name: companyName,
        dnbCompanyId: companyDuns || "",
        country: companyCountry || "",
        requestedCreditLimit: parseFloat(creditLimits[companyId]) || 0,
        view: 1,
        ticker: companyTicker || "",
        parentCompanyName: parentCompanyName || "",
        parentCountry: companyCountry || "",
        address: companyAddress || "",
        dunsControlStatus: dunsControlStatus || null,
        website: dnbWebsite || "",
      };

      const companyCreatedResponse = await createCompanyFromPlatform(createData);
      recordCreatedCompany(companyCreatedResponse, createData, request);
      if (!isCurrentCreation(request)) return;
      companyAdded();

      if (props.open && !companyTree) return;
      if (selectedOption === "Prospect") {
        setCompleted(true);
        setActiveStep(4);
      }
      if (isVerifyEntity) {
        handleOptionsModalClose();
        handleDelete();
        toast.success(`Verify entity Successfully!`, {
          bodyStyle: {
            fontWeight: "bold",
          },
        });
      }
      handleForward();
    } catch (error) {
      if (!isCurrentCreation(request)) return;
      console.error("Error adding company:", error);
      toast.error("Failed to add company. Please try again.");
    } finally {
      finishCompanyCreation(request);
    }
  };

  const companyAdded = () => {
    setError(false);
    setDisabled(false);
    setShowSearchResults(false);
    setOpen(false);
    setCompanyCountryValue("");
    setCompanyStateValue("");
    setCompanyStreetValue("");
    setCompanyZipCode("");
    setTicker("");
    setIsPublic(false);
  }

  const handleSelectClick = async (company) => {
    setParentSelectedCompany(company);
    return null;
  }
  const handleCountryISOCodeChange = (event, value) => {
    // setCountryISOCode(value["alpha-2"]);
    if (value) {
      console.log(value['alpha-2']);
      setCountryISOCode(value['alpha-2']);
      setCompanyCountryValue(value?.name);
    } else {
      setCountryISOCode(null);
      setCompanyCountryValue("");
    }
  }

  const handleYesClick = async () => {
    setAddCompanyWithoutParent(false);
    setAddParentCompany(true);
  }

  const handleNoClick = async () => {
    handleAddCompanyClick();
    setAddParentCompany(false);
    setParentCompanyDailog(false);
    setShowSearchResults(false);
    setShowParentCompanySearchResultsDialog(false);
  }

  const handleModalOpen = () => {
    setDisabled(false);
    setOpen(true);
    setShowSearchResults(false);
    setCompanyNameValue("");
    setCompanyCountryValue("");
    setRequestedCreditLimit("");
    setCompanyDnbId("");
    setCompanySearchResults([]);
    setError(false);
    setTicker("");
    setIsPublic(false);
    setCompanyRegistrationNumber("");
    setCountryISOCode("");
  };

  const handleModalClose = (event) => {
    // setOpen(!open);
    setModalOpen(false)
    setDisabled(false);
  };

  const handleCloseClick = () => {
    setOpen(false);
    setCompanyCountryValue("");
    setCompanyNameValue("");
    setCompanyStateValue("");
    setCompanyStreetValue("");
    setCompanyZipCode("");
    setError(false);
    setTicker("");
    setIsPublic(false);
    setCompanyRegistrationNumber("");
    setCountryISOCode("");
  };

  const insertDnbDataToJson = useCallback(async (dnbData) => {
    if (dnbData) {
      const jsonDataArray = [];
      try {
        // Handle new API response structure
        let searchCandidates = dnbData;
        if (dnbData.success !== undefined) {
          // New API response structure: { success: true, data: {...}, message: "..." }
          searchCandidates = dnbData.data?.searchCandidates || [];
        } else if (dnbData.searchCandidates) {
          // Old API response structure: { searchCandidates: [...] }
          searchCandidates = dnbData.searchCandidates;
        } else if (Array.isArray(dnbData)) {
          // Direct array
          searchCandidates = dnbData;
        }

        if (Array.isArray(searchCandidates)) {
          searchCandidates.forEach((data) => {
            if (data.organization) {
          jsonDataArray.push(data.organization);
            }
        });
        }

        setDnbJsonData((prevDnbJsonData) => {
          // Filter and Merge Unique Object in an Array
          const uniqueNamesSet = new Set();

          // Merge arrays while filtering out duplicate names
          const mergedArray = [...jsonDataArray, ...prevDnbJsonData].filter((obj) => {
            const isUnique = !uniqueNamesSet.has(parseInt(obj.duns));
            uniqueNamesSet.add(parseInt(obj.duns));
            return isUnique;
          });
          return mergedArray;
        });
        
        console.log("dnbData processed and merged successfully");
      } catch (error) {
        console.error("Error processing dnbData: ", error);
      }
    }
  }, []);

  
  const handleCheckboxChange = (company) => {
    if (selectedCompanies.some((selected) => selected.organization.duns === company.organization.duns)) {
      setSelectedCompanies(selectedCompanies.filter((selected) => selected.organization.duns !== company.organization.duns));

      const { [company.organization.duns]: _, ...updatedCreditLimits } = creditLimits;
      setCreditLimits(updatedCreditLimits);
    } else {
      setSelectedCompanies([...selectedCompanies, company]);

      setCreditLimits((prev) => ({
        ...prev,
        [company.organization.duns]: '',
      }));
    }
  };
  const handleRequestedCreditLimitChange = (company, value) => {
    const companyId = company.organization?.duns || company.uniqueId;
    setCreditLimits((prev) => ({
      ...prev,
      [companyId]: value,
    }));
  };

  const handleIsCompanyPublicChange = (value) => {
    setIsPublic(value);
    if (!value) setTicker("");
  };

  const handleTickerValueChange = (event) => {
    setTicker(event.target.value);
  };

  const handleCompanyRegistrationNumber = (event) => {
    setCompanyRegistrationNumber(event.target.value);
  }

  const disableAllFields = companyRegistrationNumber?.length > 0;

  const handleOptionsModalOpen = () => {
    // Reset all states to ensure modal opens fresh
    setDisabled(false);
    setModalOpen(true);
    
    // Reset stepper and completion states
    setActiveStep(0);
    setCompleted(false);
    setShowLeftButton(false);
    
    // Reset search and selection states
    setSelectedOption(null);
    setSelectedCompanies([]);
    setSearchOption(null);
    
    // Reset form fields
    setCompanyNameValue("");
    setCompanyCountryValue("");
    setCompanyStateValue("");
    setCompanyStreetValue("");
    setCompanyZipCode("");
    setTicker("");
    setCompanyRegistrationNumber("");
    setCountryISOCode("");
    setRequestedCreditLimit("");
    setIsPublic(false);
    setCompanyDnbId("");
    
    // Reset parent company states
    setAddParentCompany(false);
    setParentCompanyName("");
    setParentCompanyCountry("");
    setIsParentCompanyPublic(false);
    setParentCompanyTicker("");
    setParentSelectedCompany(null);
    
    // Reset segment states
    setSelectedSegmentForCompany(null);
    setSkipSegmentSelection(false);
    
    // Reset search results and errors
    setCompanySearchResults([]);
    setPerplexityResponse(null);
    setError(false);
    setErrorTxt("");
    setIsLoading(false);
    
    // Reset credit limits
    setCreditLimits({});
    
    // Reset modal states
    setShowSearchResults(false);
    setShowParentCompanySearchResultsDialog(false);
    setShowSegmentDialog(false);
    setIsAddCompanyManuallyModelOpen(false);
  };

  const handleOptionsModalClose = () => {
    setSelectedOption(null)
    setSelectedCompanies([])
    setActiveStep(0);// reset stepper
    setCompleted(false);
    setModalOpen(false);
    setShowLeftButton(false);
    setOpenAddCompanyModal(false);  
    if (props.open) onClose()
  };

  const handleSearchOptionChange = (option) => {
    setSearchOption(option);
    // Do not call handleModalOpen() here!
    // Only set search option and reset DNB modal state if needed
  };

  /*const handleCountryValueChange = (event, value) => {
    setCompanyCountryValue(value?.name);
  }*/

  const handleCheckboxChangePerplexity = (company) => {
    if (selectedCompanies.some((selected) => selected.uniqueId === company.uniqueId)) {
      setSelectedCompanies(selectedCompanies.filter((selected) => selected.uniqueId !== company.uniqueId));

      const { [company.uniqueId]: _, ...updatedCreditLimits } = creditLimits;
      setCreditLimits(updatedCreditLimits);
    } else {
      setSelectedCompanies([...selectedCompanies, company]);

      setCreditLimits((prev) => ({
        ...prev,
        [company.uniqueId]: '',
      }));
    }
  };

  const setPerplexityResponseData = useCallback((data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.error("Invalid or empty data received");
      return;
    }

    const modifiedData = data.map((company, index) => {
      if (!company || !company.primary_name || !company.primary_name.data) {
        console.error(`Invalid company data at index ${index}`);
        return null;
      }
      return {
        ...company,
        uniqueId: `${company.primary_name.data}-${index}`,
      };
    }).filter(Boolean); // Remove any null entries

    if (modifiedData.length > 0) {
      setPerplexityResponse(modifiedData);
      toast.success("Found alternative company information online.");
    } else {
      console.error("No valid company data found after processing");
      toast.warning("No valid company information found online.");
    }
  }, []);

  const openAISearchFallback = useCallback(async (searchText, searchCountry, searchTicker) => {
    try {
      if(!searchText)
        searchText = searchTicker || companyRegistrationNumber;
      const result = await searchCompanyOpenAI({
        searchText,
        searchCountry: searchCountry || "",
        searchTicker: searchTicker || ""
      });

      if (result && result.success && result.data && result.data.length > 0) {
        return result.data;
      }
      
      return null;
    } catch (error) {
      console.error("Error in OpenAI Search Fallback function:", error);
      return null;
    }
  }, [companyRegistrationNumber]);

  const perplexitySearchFallback = useCallback(async (searchText) => {
    try {
      if(!searchText)
        searchText = ticker || companyRegistrationNumber;
      const result = await searchCompanyPerplexity({
        searchText,
        countryName: companyCountryValue
      });

      if (result && result.success && result.data && result.data.length > 0) {
        return result.data;
      }
      
      return null;
    } catch (error) {
      console.error("Error in Perplexity Search Fallback function:", error);
      return null;
    }
  }, [companyCountryValue, ticker, companyRegistrationNumber]);

  const processNameAndSearchAgain = useCallback(async (companyName) => {
    const pattern = /[^a-zA-Z0-9\s]/;
    let companyFinalName = "";

    if (pattern.test(companyName)) {
      const specialCharacters = ["-", "!", "$", "&", ",", "@", "%", "!", "."];
      const inputString = companyName?.trim();

      // Step 1: Omitting Special Characters
      const regex = new RegExp(`[${specialCharacters.join("\\")}]`, "g");
      const stringWithoutSpecialChars = inputString.replace(regex, "");

      // Step 2: Truncating the Last Expression(Word) of the Name
      const words = stringWithoutSpecialChars.split(" ");
      const truncatedName = words.slice(0, -1).join(" ");

      // Step 3: Truncating Anything Past a Special Character
      const indexOfSpecialChar = truncatedName.indexOf(specialCharacters[0]);
      const finalResult =
        indexOfSpecialChar !== -1
          ? truncatedName.slice(0, indexOfSpecialChar)
          : truncatedName;
      companyFinalName = finalResult;
    } else {
      companyFinalName = companyName;
    }

    try {
      console.log("Company Final Name -> ", companyFinalName);
      const searchParams = {
        name: companyFinalName,
        tenantId: tenantId,
        isPaid: currentTenant?.isPaid
      };

      const companies = await searchCompaniesAdvanced(tenantId, searchParams);
      console.log("Search Results", companies);

      if (companies && companies.length > 0) {
        setShowSearchResults(true);
        setCompanySearchResults(companies);
        setDisabled(false);
      } else {
        setCompanySearchResults([]);
        setDisabled(false);
      }
      setActiveStep(2);
    } catch (error) {
      console.log("error while searching", error);
      //TODO:Temp fix recieving 500 if no companies found
      setCompanySearchResults([]);
      setDisabled(false);
      setActiveStep(2);
    }
  }, [tenantId, currentTenant]);

  const searchCompany = useCallback(async () => {
    // Clear previous results at the start of every search
    clearSearchState();

    console.log("[searchCompany] Search started");
    setIsLoading(true);
  
    const isSearchWithRegistrationNumber = disableAllFields;
  
    let searchResults = undefined;
    setDisabled(true);
  
    console.log("[searchCompany] Params:", {
      companyNameValue,
      companyRegistrationNumber,
      ticker,
      countryISOCode,
      companyCountryValue,
      isSearchWithRegistrationNumber
    });
  
    if ((companyNameValue.trim() === "" && companyRegistrationNumber === "" && !ticker.trim())) {    
      console.warn("[searchCompany] No search input provided");
      setError(true);
      setDisabled(false);
      setIsLoading(false);
      return;
    }
  
    try {
      if (ticker.trim()) {
        console.log("[searchCompany] Searching by ticker:", ticker);
        searchResults = await companyApi.searchCompanyDnBWithTicker({
          tenantId: tenantId,
          ticker: ticker,
          iso2Code: countryISOCode,
        });
      } else if (isSearchWithRegistrationNumber) {
        console.log("[searchCompany] Searching by registration number:", companyRegistrationNumber);
        searchResults = await companyApi.searchCompanyDnBWithRegistration({
          tenantId: tenantId,
          registrationNumber: companyRegistrationNumber,
          iso2Code: countryISOCode,
        });
      } else {
        console.log("[searchCompany] Searching by name:", companyNameValue);
        searchResults = await companyApi.searchCompanyDnB({
          name: companyNameValue,
          tenantId: tenantId,
          iso2Code: countryISOCode,
          countryName: companyCountryValue
        });
      }
  
      if (searchResults) {
        console.log("[searchCompany] responseBody", searchResults);
  
        // Handle new API response structure
        let searchData = searchResults;
        if (searchResults.success !== undefined) {
          // New API response structure: { success: true, data: {...}, message: "..." }
          searchData = searchResults.data;
          console.log("[searchCompany] Using new API response structure");
        }
  
        // Check for API errors (400, 424, 500+) or empty results
        const isApiError = searchResults.response?.status === 400 || 
                          searchResults.response?.status === 424 || 
                          searchResults.response?.status >= 500;
        
        const hasNoResults = searchData?.searchCandidates?.length === 0;
  
        if (isApiError || hasNoResults) {
          let toastMessage = "";
          
          if (searchResults.response?.status === 400) {
            console.info("[searchCompany] DNB search is disabled, searching alternative sources...");
            toastMessage = "CrediArc company search is disabled, searching alternative sources...";
          } else if (searchResults.response?.status === 424) {
            console.info("[searchCompany] DNB service temporarily unavailable, searching alternative sources...");
            toastMessage = "CrediArc company search is temporarily unavailable, searching alternative sources...";
          } else if (searchResults.response?.status >= 500) {
            console.info("[searchCompany] DNB service error, searching alternative sources...");
            toastMessage = "CrediArc company search error, searching alternative sources...";
          } else {
            console.info("[searchCompany] Company not found in our database. Searching alternative sources...");
            toastMessage = "Company not found in our database. Searching alternative sources...";
          }
          
          toast.info(toastMessage);
  
          try {
            const searchTerm = companyNameValue || ticker || companyRegistrationNumber;
            
            // Try OpenAI first
            console.log("[searchCompany] Trying OpenAI fallback with:", searchTerm);
            const openAIResults = await openAISearchFallback(searchTerm, companyCountryValue, ticker);
            console.log("[searchCompany] OpenAI fallback results:", openAIResults);
            
            if (openAIResults && openAIResults.length > 0 && openAIResults[0]?.primary_name !== "Company not found") {
              const filteredResults = openAIResults.filter(company =>
                company.primary_name &&
                company.primary_name.data
              );
  
              if (filteredResults.length > 0) {
                console.log("[searchCompany] OpenAI fallback found results:", filteredResults);
                setPerplexityResponseData(filteredResults);
                searchResults = [];
                setIsLoading(false);
                setActiveStep(2);
                return;
              } 
            } 
  
            // If OpenAI fails, try Perplexity
            console.log("[searchCompany] Trying Perplexity fallback with:", searchTerm);
            const perplexityResults = await perplexitySearchFallback(searchTerm);
            console.log("[searchCompany] Perplexity fallback results:", perplexityResults);
            
            if (perplexityResults && perplexityResults.length > 0 && perplexityResults[0]?.primary_name !== "Company not found") {
              const filteredResults = perplexityResults.filter(company =>
                company.primary_name &&
                company.primary_name.data
              );
  
              if (filteredResults.length > 0) {
                console.log("[searchCompany] Perplexity fallback found results:", filteredResults);
                setPerplexityResponseData(filteredResults);
                searchResults = [];
                setIsLoading(false);
                setActiveStep(2);
                return;
              } 
            } 
  
            // If both fallbacks fail
            searchResults = [];
            console.warn("[searchCompany] No company information found in fallbacks. Prompting manual entry.");
            toast.warning("No company information found. Please enter details manually.");
            
          } catch (searchError) {
            console.error("[searchCompany] Error in search fallback:", searchError);
            searchResults = [];
            toast.warning("No company information found. Please enter details manually.");
          }
        } 
      }
  
      console.log("[searchCompany] Search Result --> ", searchResults);
  
      if (searchResults === undefined) {
        console.log("[searchCompany] searchResults undefined, calling processNameAndSearchAgain");
        processNameAndSearchAgain(companyNameValue);
      } else {
        // Handle new API response structure
        let searchData = searchResults;
        if (searchResults.success !== undefined) {
          searchData = searchResults.data;
        }
  
        let candidates = [];
        if (Array.isArray(searchData?.searchCandidates)) {
          candidates = searchData.searchCandidates;
          console.log("[searchCompany] Using searchCandidates:", candidates);
        } else if (Array.isArray(searchData?.matchCandidates)) {
          candidates = searchData.matchCandidates;
          console.log("[searchCompany] Using matchCandidates:", candidates);
        }
  
        // Now filter/process candidates as usual
        let filteredResult = candidates.filter((element) => {
          const companyNameMatch = element?.organization?.primaryName
            ?.toLowerCase()
            ?.includes(companyNameValue?.toLowerCase());
  
          const countryName = element?.organization?.primaryAddress?.addressCountry?.name?.toLowerCase();
          const countryCode = element?.organization?.primaryAddress?.addressCountry?.isoAlpha2Code?.toLowerCase();
  
          const countryMatch =
            countryName === companyCountryValue?.toLowerCase() ||
            countryCode === companyCountryValue?.toLowerCase() ||
            companyCountryValue?.toLowerCase().includes(countryName) ||
            countryName?.includes(companyCountryValue?.toLowerCase());
  
          return companyNameMatch && countryMatch;
        });
  
        setCompanySearchResults(filteredResult);
        setActiveStep(2);
      }
  
      console.log("[searchCompany] Inserting DNB data to JSON", searchResults);
      insertDnbDataToJson(searchResults);
      
    } catch (error) {
      console.error("[searchCompany] Error in main search:", error);
      
      // If there's a network error or API error, try fallbacks
      if (error.response?.status >= 400 || error.code === 'ERR_BAD_REQUEST') {
        console.info("[searchCompany] API error caught, attempting fallbacks...");
        toast.info("Service temporarily unavailable, searching alternative sources...");
        
        try {
          const searchTerm = companyNameValue || ticker || companyRegistrationNumber;
          
          // Try OpenAI first
          console.log("[searchCompany] Trying OpenAI fallback after error with:", searchTerm);
          const openAIResults = await openAISearchFallback(searchTerm, companyCountryValue, ticker);
          console.log("[searchCompany] OpenAI fallback results after error:", openAIResults);
          
          if (openAIResults && openAIResults.length > 0 && openAIResults[0]?.primary_name !== "Company not found") {
            const filteredResults = openAIResults.filter(company =>
              company.primary_name &&
              company.primary_name.data
            );
  
            if (filteredResults.length > 0) {
              console.log("[searchCompany] OpenAI fallback found results after error:", filteredResults);
              setPerplexityResponseData(filteredResults);
              setIsLoading(false);
              setActiveStep(2);
              return;
            } 
          } 
  
          // If OpenAI fails, try Perplexity
          console.log("[searchCompany] Trying Perplexity fallback after error with:", searchTerm);
          const perplexityResults = await perplexitySearchFallback(searchTerm);
          console.log("[searchCompany] Perplexity fallback results after error:", perplexityResults);
          
          if (perplexityResults && perplexityResults.length > 0 && perplexityResults[0]?.primary_name !== "Company not found") {
            const filteredResults = perplexityResults.filter(company =>
              company.primary_name &&
              company.primary_name.data
            );
  
            if (filteredResults.length > 0) {
              console.log("[searchCompany] Perplexity fallback found results after error:", filteredResults);
              setPerplexityResponseData(filteredResults);
              setIsLoading(false);
              setActiveStep(2);
              return;
            } 
          } 
  
          // If both fallbacks fail
          console.warn("[searchCompany] No company information found in fallbacks after error. Prompting manual entry.");
          toast.warning("No company information found. Please enter details manually.");
          
        } catch (fallbackError) {
          console.error("[searchCompany] Error in fallback after main error:", fallbackError);
          toast.error("An error occurred during search. Please try again or enter details manually.");
        }
      } else {
        toast.error("An error occurred during search. Please try again.");
      }
    }
  
    setIsLoading(false);
    setDisabled(false);
    console.log("[searchCompany] Search finished");
  }, [companyNameValue, companyRegistrationNumber, ticker, countryISOCode, companyCountryValue, currentTenant, tenantId, disableAllFields, openAISearchFallback, perplexitySearchFallback, processNameAndSearchAgain, insertDnbDataToJson, setPerplexityResponseData]);
  useEffect(() => {
    if (props.open && initialSearchTerm && initialCountry) {
      if (!initialSearchPerformed.current) {
        setCompanyNameValue(initialSearchTerm);
        setCompanyCountryValue(initialCountry);
        setSearchOption("name");
        setActiveStep(1);
        searchCompany();
        initialSearchPerformed.current = true;
      }
    } else {
      initialSearchPerformed.current = false;
    }
  }, [props.open, initialSearchTerm, initialCountry, searchCompany]);

  const handleClose = () => {
    setError(false);
    setSelectedOption(null);
    setCompanyRegistrationNumber("");
    setError(false);
    setDisabled(false);
    setShowSearchResults(false);
    setOpen(false);
    setCompanyCountryValue("");
    setCompanyStateValue("");
    setCompanyStreetValue("");
    setCompanyZipCode("");
    setTicker("");
    setIsPublic(false);
    setSelectedCompanies([]);
    setSelectedSegmentForCompany(null);
    setSkipSegmentSelection(false);
    setCompanyNameValue("");
  };

  const formatAddress = (primaryAddress) => {
    if (!primaryAddress) return "";
    const { streetAddress, addressLocality, addressCounty, postalCode, addressCountry } = primaryAddress;
    return `${streetAddress?.line1 || ""}, ${addressLocality?.name || ""}, ${addressCounty?.name || ""}, ${postalCode || ""}, ${addressCountry?.name || ""}`;
  };

  const handleCompanyNameChange = (event) => {
    setCompanyNameValue(event.target.value);
  };

  const toggleAddCompanyManuallyModal = () => {
    if (isAddCompanyManuallyModelOpen) handleOptionsModalClose();
    setIsAddCompanyManuallyModelOpen(!isAddCompanyManuallyModelOpen);
  };

  const handleAddParentCompany = async () => {
    const request = beginCompanyCreation();
    if (!request) return;
    try {
      if (!parentCompanyName.trim()) {
        toast.error("Parent company name is required");
        return;
      }
      
      if (!parentCompanyCountry) {
        toast.error("Parent company country is required");
        return;
      }
      
      // Create parent company first
      const parentCompanyData = {
        tenantId: request.tenantId,
        name: parentCompanyName,
        country: parentCompanyCountry,
        requestedCreditLimit: 0,
        view: 1,
        ticker: "",
        parentCompanyName: "",
        parentCountry: "",
        address: ""
      };
      
      const createdParentCompany = await createCompanyFromPlatform(parentCompanyData);
      recordCreatedCompany(createdParentCompany, parentCompanyData, request);
      if (!isCurrentCreation(request)) return;
      if (createdParentCompany) {
        setParentCompanyName(createdParentCompany.data.name);
        setParentCompanyCountry(createdParentCompany.data.country);
        setCompanyDnbId(createdParentCompany.data.dnbCompanyId || "");
        
    setAddParentCompany(false);
        toast.success(`Parent company "${parentCompanyName}" created successfully!`);
      }
      
    } catch (error) {
      if (!isCurrentCreation(request)) return;
      console.error("Error creating parent company:", error);
      toast.error("Failed to create parent company. Please try again.");
    } finally {
      finishCompanyCreation(request);
    }
  };

  const handleAddCompany = async () => {
    // Robust validation: check if we have either companyNameValue OR selected companies
    if (!companyNameValue && (!selectedCompanies || selectedCompanies.length === 0)) {
      setError(true);
      setErrorTxt("This field is required");
      return;
    }
    console.log("companyNameValue", companyNameValue);
    console.log("selectedCompanies", selectedCompanies);

    const request = beginCompanyCreation();
    if (!request) return;
    try {
      // Check if we need to show segment dialog for search add
      const shouldShowSegmentDialog = !selectedSegment && 
        !selectedSegmentForCompany && 
        !skipSegmentSelection && 
        segments.length > 0;
      
      if (shouldShowSegmentDialog) {
        setShowSegmentDialog(true);
        setAddMode("search");
        setIsAddingCompany(false);
        return;
      }
      
      setDisabled(true);
      setError(false);
      setErrorTxt("");
      
      // Validate that we have selected companies
      if (!selectedCompanies || selectedCompanies.length === 0) {
        throw new Error('No company selected. Please select a company from the search results.');
      }
      
      const selectedCompany = selectedCompanies[0];
      console.log("selectedCompany", selectedCompany);

      // Robust data extraction with proper null checks
      let companyDuns, companyTicker, companyAddress, companyCountry, actualCompanyName, dunsControlStatus, dnbWebsite;
      
      if (selectedCompany.organization) {
        // DNB format
        companyDuns = selectedCompany.organization.duns || null;
        companyTicker = selectedCompany.organization.tickerSymbol || "";
        companyAddress = formatAddress(selectedCompany.organization.primaryAddress) || "";
        companyCountry = selectedCompany.organization.primaryAddress?.addressCountry?.name || "";
        actualCompanyName = selectedCompany.organization.primaryName || "";
        dunsControlStatus = selectedCompany.organization?.dunsControlStatus || null;
        dnbWebsite = selectedCompany.organization?.domain || null;
      } else if (selectedCompany.primary_name) {
        // Perplexity/OpenAI format
        companyDuns = selectedCompany.duns?.data || null;
        companyTicker = selectedCompany.ticker?.data || "";
        companyAddress = selectedCompany.locations?.data?.[0]?.full_address || "";
        companyCountry = selectedCompany.locations?.data?.[0]?.country || "";
        actualCompanyName = selectedCompany.primary_name.data || "";
      } else {
        // Fallback to companyNameValue if no structured data
        companyDuns = null;
        companyTicker = ticker || "";
        companyAddress = "";
        companyCountry = companyCountryValue || "";
        actualCompanyName = companyNameValue || "";
      }
      
      const companyId = companyDuns || selectedCompany.uniqueId || `temp-${Date.now()}`;

      console.log("Extracted company data:", {
        companyDuns,
        companyTicker,
        companyAddress,
        companyCountry,
        actualCompanyName,
        companyId
      });

      if (!request.tenantId) {
        throw new Error('TenantId is required but was null');
      }

      if (!actualCompanyName) {
        throw new Error('Company name is required but could not be extracted from search results');
      }

      // Check if company exists
      const existingCompany = false;
      if (existingCompany) {
        // Update existing company
        const updateData = {
          tenantId: request.tenantId,
          name: actualCompanyName,
          dnbCompanyId: companyDnbId || "",
          country: companyCountryValue || "",
          requestedCreditLimit: parseFloat(creditLimits[companyId]) || 0,
          view: 1,
          ticker: tickerValue || "",
          parentCompanyName: parentCompanyName || "",
          parentCountry: parentCompanyCountry || "",
          address: companyStreetValue || "",
          segmentID: selectedSegment?.id || selectedSegmentForCompany?.id || null,
          dunsControlStatus: dunsControlStatus || null,
          website: dnbWebsite || "",
        };

        const updatedCompany = await updateCompany(existingCompany.id, updateData);
        recordCreatedCompany(updatedCompany, updateData, request);
      } else {
        // Create new company
        const createData = {
          tenantId: request.tenantId,
          name: actualCompanyName,
          dnbCompanyId: companyDuns || "",
          country: companyCountry || "",
          requestedCreditLimit: parseFloat(creditLimits[companyId]) || 0,
          view: 1,
          ticker: companyTicker || "",
          parentCompanyName: parentCompanyName || "",
          parentCountry: companyCountry || "",
          address: companyAddress || "",
          dunsControlStatus: dunsControlStatus || null,
          website: dnbWebsite || ""
        };

        // Add segmentID if available
        if (selectedSegment?.id || selectedSegmentForCompany?.id) {
          createData.segmentID = selectedSegment?.id || selectedSegmentForCompany?.id;
        }

        console.log("Creating company with data:", createData);
        const companyCreatedResponse = await createCompanyFromPlatform(createData);
        recordCreatedCompany(companyCreatedResponse, createData, request);
      }

      if (!isCurrentCreation(request)) return;
      setSelectedSegmentForCompany(null);
      setSkipSegmentSelection(false);
      toast.success(`${actualCompanyName} Added Successfully!`, {
        bodyStyle: {
          fontWeight: "bold",
        },
      });

      companyAdded();
      handleNext();
      setIsAddCompanyManuallyModelOpen(false);
    } catch (error) {
      if (!isCurrentCreation(request)) return;
      console.error("Error adding company:", error);
      toast.error(error.message || "Failed to add company. Please try again.");
      setCompanyNameValue("");
    } finally {
      finishCompanyCreation(request);
    }
  };

  // Enhanced parent company search function
  const searchParentCompany = async () => {
    try {
      setIsLoading(true);
      
      // Search for parent company using the same APIs
      const searchResults = await searchCompanyDnB({
        name: parentCompanyName,
        tenantId: tenantId
      });
      
      if (searchResults && searchResults.length > 0) {
        setParentCompanySearchResults(searchResults);
        setShowParentCompanySearchResultsDialog(true);
      } else {
        // Fallback to OpenAI search
        const openAIResults = await searchCompanyOpenAI({
          searchText: parentCompanyName,
          searchCountry: parentCompanyCountry,
          tenantId: tenantId
        });
        if (openAIResults && openAIResults.length > 0) {
          setParentCompanySearchResults(openAIResults);
          setShowParentCompanySearchResultsDialog(true);
        } else {
          // Fallback to Perplexity search
          const perplexityResults = await searchCompanyPerplexity({
            searchText: parentCompanyName
          });
          if (perplexityResults && perplexityResults.length > 0) {
            setParentCompanySearchResults(perplexityResults);
            setShowParentCompanySearchResultsDialog(true);
          } else {
            toast.warning("No parent company found. You can add it manually.");
            setAddParentCompany(true);
          }
        }
      }
    } catch (error) {
      console.error("Error searching parent company:", error);
      toast.error("Failed to search parent company. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Enhanced parent company selection handler
  const handleParentCompanySelect = async (company) => {
    try {
      setParentSelectedCompany(company);
      
      // Extract company details based on the data structure
      let companyName, companyCountry, companyDuns;
      
      if (company.organization) {
        // DNB format
        companyName = company.organization.primaryName;
        companyCountry = company.organization.primaryAddress?.addressCountry?.name;
        companyDuns = company.organization.duns;
      } else if (company.primary_name) {
        // Perplexity/OpenAI format
        companyName = company.primary_name.data;
        companyCountry = company.locations?.data?.[0]?.country || "";
        companyDuns = company.duns?.data || "";
      }
      
      setParentCompanyName(companyName);
      setParentCompanyCountry(companyCountry);
      setCompanyDnbId(companyDuns);
      
      setShowParentCompanySearchResultsDialog(false);
      toast.success(`Parent company "${companyName}" selected successfully!`);
      
    } catch (error) {
      console.error("Error selecting parent company:", error);
      toast.error("Failed to select parent company. Please try again.");
    }
  };

  // Add this new handler for manual add
  const handleManualAddClick = async () => {
    if (!companyNameValue.trim()) {
      setError(true);
      setErrorTxt("Company Name is required");
      return;
    }
    if (!companyCountryValue) {
      setError(true);
      setErrorTxt("Company Country is required");
      return;
    }
    // Add more field validations as needed
    setError(false);
    setErrorTxt("");
    const request = beginCompanyCreation();
    if (!request) return;
    try {
      // Check if we need to show segment dialog for manual add
      const shouldShowSegmentDialog = !selectedSegment && 
        !selectedSegmentForCompany && 
        !skipSegmentSelection && 
        segments.length > 0;
      
      if (shouldShowSegmentDialog) {
        setShowSegmentDialog(true);
        setAddMode("manual");
        return;
      }
      
      // Create company data
      const countryName = companyCountryValue 
        ? CountryISOCodes.find(option => option["alpha-2"] === companyCountryValue)?.name || companyCountryValue
        : "";
      
      const createData = {
        tenantId: request.tenantId,
        name: companyNameValue,
        country: countryName,
        requestedCreditLimit: requestedCreditLimit,
        isPublic,
        parentCompanyName: addParentConpany ? parentCompanyName : undefined,
        parentCompanyCountry: addParentConpany ? parentCompanyCountry : undefined,
        parentCompanyTicker: addParentConpany && isParentCompanyPublic ? parentCompanyTicker : undefined,
      };

      // Add segmentID if available
      if (selectedSegment?.id || selectedSegmentForCompany?.id) {
        createData.segmentID = selectedSegment?.id || selectedSegmentForCompany?.id;
      }

      const companyCreatedResponse = await createCompanyFromPlatform(createData);
      recordCreatedCompany(companyCreatedResponse, createData, request);
      if (!isCurrentCreation(request)) return;
      
      toast.success(`${companyNameValue} Added Successfully!`);
      setOpen(false);
      setCompanyNameValue("");
      setCompanyCountryValue("");
      setRequestedCreditLimit("");
      setIsPublic(false);
      setAddParentCompany(false);
      setParentCompanyName("");
      setParentCompanyCountry("");
      setIsParentCompanyPublic(false);
      setParentCompanyTicker("");
      setSelectedSegmentForCompany(null);
      setSkipSegmentSelection(false);
    } catch (error) {
      if (!isCurrentCreation(request)) return;
      toast.error(error.message || "Failed to add company. Please try again.");
      setCompanyNameValue(""); // Clear company name on error
    } finally {
      finishCompanyCreation(request);
    }
  };

  useEffect(() => {
    if (modalOpen || openAddCompanyModal || props.open) {
      setDisabled(false);
      setCompanyNameValue(initialSearchTerm || "");
    }
  }, [modalOpen, openAddCompanyModal, props.open, initialSearchTerm]);

  const clearSearchState = () => {
    setCompanySearchResults([]);
    setPerplexityResponse(null);
    setSelectedCompanies([]);
    setSelectedSegmentForCompany(null);
    setSkipSegmentSelection(false);
    setError(false);
    setErrorTxt("");
    setIsLoading(true);
    setDisabled(true);
  };

  return (
    <React.Fragment>
      <div>
        {
          companyTree ? null : isVerifyEntity ? <Button
            onClick={handleOptionsModalOpen}
            style={{
              color: "#5186EC",
              width: "104px",
              height: "17px",
              fontSize: "14px",
              textTransform: "none",
              fontFamily: "Rubik, sans-serif",
              fontWeight: "250",
              display: "flex",
              alignItems: "center"
            }}
            sx={{
              display:
                isAdmin &&
                  location.pathname === "/"
                  ? "none"
                  : "inline",
            }}
          >
            Verify Entity
          </Button> : <Fab
            color="primary"
            aria-label="add"
            style={fabStyle}
            onClick={handleOptionsModalOpen}
          >
            <AddIcon />
          </Fab>
        }
        <Modal open={Boolean(modalOpen || openAddCompanyModal || props.open)} style={modalStyle} onClose={handleOptionsModalClose}>
          <div style={{ color: "#2F3D63" }}>
            <Box sx={style}>
              <IconButton 
                style={{ position: "absolute", top: "20px", left: "30px" }} 
                onClick={handleOptionsModalClose}
                aria-label="close"
              >
                <img style={{ width: "23px", height: "23px" }} src={Close} alt="close" />
              </IconButton>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  textAlign: "center",
                  padding: 2,
                  color: "#2F3D63"
                }}
              >
                Add Company
              </Typography>
              <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />} style={stepperStyle}>
                {steps.map((label, index) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={ColorlibStepIcon} icon={index + 1} ></StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {activeStep === 0 && (
                  <div>
                    <Typography sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#2F3D63",
                      position: "absolute",
                      top: "55%",
                      left: "50%",
                      transform: "translate(-50%,-50%)"
                    }}>
                      Search By
                    </Typography>
                    <div style={buttonsStyle}>
                      <Button style={buttonStyle} variant="contained" onClick={() => {
                        handleSearchOptionChange("name");
                        handleNext();
                      }}>
                        Name
                      </Button>
                      <Button style={buttonStyle} variant="contained" onClick={() => {
                        handleSearchOptionChange("id");
                        handleNext();
                      }}>
                        ID
                      </Button>
                      <Button style={buttonStyle} variant="contained" onClick={() => {
                        handleSearchOptionChange("ticker");
                        handleNext();
                      }}>
                        Ticker
                      </Button>
                    </div>
                  </div>
                )}
                {activeStep === 1 && searchOption === "name" && isLoading && (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      margin: 2,
                      padding: 2,
                    }}
                  >
                    <CircularProgress />
                  </Box>
                )}
                {activeStep === 1 && searchOption === "name" && !isLoading && (
                  <div style={containerStyle}>
                    <Typography sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#2F3D63",
                      marginBottom: "20px"
                      // position:"absolute",
                      // top:"55%",
                      // left:"50%",
                      // transform:"translate(-50%,-50%)"
                    }}>
                      Search By Name
                    </Typography>
                    <Typography>Company Name</Typography>
                    <TextField
                      id="companyName"
                      sx={inputStyle}
                      helperText={error ? errorTxt : ""}
                      label=""
                      variant="outlined"
                      required={true}
                      value={companyNameValue}
                      onChange={handleCompanyNameChange}
                      error={error}
                    />
                    <FormControl
                      sx={{ display: "inline-flex", flexDirection: "column", marginTop: 2 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "4px",
                          marginBottom: "8px",
                        }}
                      >
                        <Typography
                          variant="body1"
                          style={{ marginTop: "9px", marginRight: "10px", fontSize: "14px" }}
                        >
                          Is Company Public?
                        </Typography>
                        <div>
                          <Button
                            // variant={!isPublic ? "contained" : "outlined"}
                            color="primary"
                            onClick={() => handleIsCompanyPublicChange(false)}
                            style={{
                              marginLeft: "10px",
                              height: "28px",
                              width: "61px",
                              background: isPublic ? "#fff" : "#5186EC4D 0% 0% no-repeat padding-box",
                              color: "#5186EC",
                              border: "1px solid #5186EC",
                              borderRadius: "10px"
                            }}
                          >
                            No
                          </Button>
                          <Button
                            // variant={isPublic ? "contained" : "outlined"}
                            color="primary"
                            style={{
                              marginLeft: "10px",
                              height: "28px",
                              width: "61px",
                              background: isPublic ? "#5186EC4D 0% 0% no-repeat padding-box" : "#fff",
                              color: "#5186EC",
                              border: "1px solid #5186EC",
                              borderRadius: "10px"
                            }}
                            onClick={() => handleIsCompanyPublicChange(true)}
                          >
                            Yes
                          </Button>

                        </div>
                      </div>
                      <div>
                        {/* <TextField
                            fullWidth
                            label="Ticker*"
                            variant="standard"
                            value={ticker}
                            onChange={handleTickerValueChange}
                          /> */}
                        <div style={{ marginTop: "20px" }}>
                          <FormControl fullWidth>
                            <Autocomplete
                              id="country-select"
                              options={CountryISOCodes}
                              style={dropdownStyle}
                              getOptionLabel={(option) => option?.name}
                              value={CountryISOCodes.find(option => option["alpha-2"] === countryISOCode) || null}
                              onChange={handleCountryISOCodeChange}
                              renderInput={(params) => <TextField {...params} label="Country" />}
                            />
                          </FormControl>
                        </div>
                      </div>
                    </FormControl>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '30px 0 25px 0', }}>
                      <Button onClick={handleBack} style={backStyle} disabled={companyTree}>Back</Button>
                      <Button variant="contained" sx={searchStyle} disabled={disabled} onClick={searchCompany}>Search</Button>
                    </div>
                  </div>
                )}
                {activeStep === 1 && searchOption === "id" && (
                  <div style={containerStyle}>
                    <Typography sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#2F3D63",
                      marginBottom: "20px"
                      // position:"absolute",
                      // top:"55%",
                      // left:"50%",
                      // transform:"translate(-50%,-50%)"
                    }}>
                      Search By ID
                    </Typography>
                    <Typography>Company Registration Number</Typography>
                    <TextField
                      id="companyRegistrationNumber"
                      label=""
                      variant="outlined"
                      sx={inputStyle}
                      value={companyRegistrationNumber}
                      required={true}
                      onChange={handleCompanyRegistrationNumber}
                      fullWidth
                    />
                    <div style={{ marginTop: "10px" }}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="country-select"
                          options={CountryISOCodes}
                          style={dropdownStyle}
                          getOptionLabel={(option) => option?.name}
                          value={CountryISOCodes.find(option => option["alpha-2"] === countryISOCode) || null}
                          onChange={handleCountryISOCodeChange}
                          renderInput={(params) => <TextField {...params} label="Country" />}
                        />
                      </FormControl>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                      <Button onClick={handleBack} sx={backStyle}>Back</Button>
                      <Button variant="contained" sx={searchStyle} disabled={!(countryISOCode) || disabled} color="primary" onClick={searchCompany}>Search</Button>
                    </div>
                  </div>
                )}
                {activeStep === 1 && searchOption === "ticker" && (
                  <div sx={containerStyle}>
                    <Typography sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#2F3D63",
                      margin: "20px 0 20px 0",

                      // position:"absolute",
                      // top:"55%",
                      // left:"50%",
                      // transform:"translate(-50%,-50%)"
                    }}>
                      Search By Ticker
                    </Typography>
                    <Typography sx={{ marginTop: "20px" }}>Ticker</Typography>
                    <TextField
                      id="ticker"
                      label=""
                      variant="outlined"
                      value={ticker}
                      required={true}
                      sx={inputStyle}
                      onChange={handleTickerValueChange}
                      fullWidth
                    />
                    <div style={{ marginTop: "10px" }}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="country-select"
                          options={CountryISOCodes}
                          style={dropdownStyle}
                          getOptionLabel={(option) => option?.name}
                          value={CountryISOCodes.find(option => option["alpha-2"] === countryISOCode) || null}
                          onChange={handleCountryISOCodeChange}
                          renderInput={(params) => <TextField {...params} label="Country" />}
                        />
                      </FormControl>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px 0 30px 0' }}>
                      <Button onClick={handleBack} sx={backStyle}>Back</Button>
                      <Button variant="contained" sx={searchStyle} color="primary" disabled={disabled} onClick={searchCompany}>Search</Button>
                    </div>
                  </div>
                )}
                {activeStep === 2 && (<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                  <Typography variant="h6" sx={{ marginTop: "10px" }}>Search Results</Typography>
                  <Typography variant="subtitle1" color="textSecondary" sx={{ fontSize: "12px" }}>
                    {perplexityResponse ? (perplexityResponse?.length || 0) : (companySearchResults?.length || 0)} companies found
                  </Typography>
                  <div style={{ position: 'relative' }}>
                    <div
                      style={{
                        maxWidth: '705px',
                        overflow: 'hidden',
                        display: 'flex',
                        gap: '10px',
                        width: '1920px',
                      }}
                      ref={listRef}
                    >
                      {perplexityResponse ? (
                        perplexityResponse?.map((company, index) => {
                          if (!company || !company.primary_name || !company.primary_name.data) {
                            return null;
                          }
                          return (
                            <div key={index} style={{ ...companyListStyle, border: "1px solid #E9E9E9" }}>
                              <ListItemButton
                                style={{
                                  border: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  width: "225px"
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input
                                    type="checkbox"
                                    style={{ marginLeft: 0, marginRight: "8px", border: "1px solid #E9E9E9" }}
                                    checked={selectedCompanies.some((selected) => selected.uniqueId === company.uniqueId)}
                                    onChange={() => handleCheckboxChangePerplexity(company)}
                                  />
                                  <ListItemText
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: "bold" }}
                                    primary={company.primary_name.data}
                                  />
                                </div>
                                <div>
                                  {company.ticker?.data && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Ticker: ${company.ticker.data}`}
                                    />
                                  )}
                                  {company.year_founded?.data && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Year Founded: ${company.year_founded.data}`}
                                    />
                                  )}
                                  {company.industry?.data && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Industry: ${company.industry.data}`}
                                    />
                                  )}
                                  {company.parent_company?.data && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Parent Company: ${company.parent_company.data}`}
                                    />
                                  )}
                                  {company.other_names?.data?.length > 0 && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Other Names: ${company.other_names.data.join(', ')}`}
                                    />
                                  )}
                                  {company.locations?.data?.length > 0 && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Locations: ${company.locations.data.map(location => `${location.location_type}: ${location.full_address}, ${location.city}, ${location.country} ${location.zip_code}`).join('; ')}`}
                                    />
                                  )}
                                  {company.operation_status?.data && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Operation Status: ${company.operation_status.data}`}
                                    />
                                  )}
                                </div>
                              </ListItemButton>
                              {selectedCompanies.some((selected) => selected.uniqueId === company.uniqueId) ? (
                                <div style={{ display: "flex", gap: "5px", padding: "5px", flexDirection: "column", justifyContent: "center" }}>
                                  <Typography sx={{ fontSize: "14px" }}>
                                    Enter Requested Amount:
                                  </Typography>
                                  <TextField
                                    value={creditLimits[company.uniqueId] || ''}
                                    onChange={(e) => handleRequestedCreditLimitChange(company, e.target.value)}
                                    sx={{
                                      '& .MuiInputBase-root': {
                                        height: '30px',
                                        border: '1px solid black',
                                        borderRadius: '4px',
                                      },
                                      '& .MuiInputLabel-root': {
                                        top: '-8px',
                                        fontSize: "12px"
                                      },
                                      '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                          borderColor: 'darkgrey',
                                        },
                                        '&:hover fieldset': {
                                          borderColor: 'black',
                                        },
                                        '&.Mui-focused fieldset': {
                                          borderColor: 'black',
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              ) : null}
                            </div>
                          );
                        })
                      ) : (
                        companySearchResults?.map((company, index) => {
                          if (!company || !company.organization) {
                            return null;
                          }
                          let showVerifiedCompany = isVerifyEntity && companyUniqueID && company.organization.duns === companyUniqueID;
                          return (
                            <div style={{ ...companyListStyle, border: showVerifiedCompany ? "2px solid #101049" : "1px solid #E9E9E9" }} key={index}> 
                              <ListItemButton
                                style={{
                                  border: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  width: "225px"
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input
                                    type="checkbox"
                                    style={{ marginLeft: 0, marginRight: "8px", border: "1px solid #E9E9E9" }}
                                    checked={selectedCompanies.some((selected) => selected.organization.duns === company.organization.duns)}
                                    onChange={() => handleCheckboxChange(company)}
                                  />
                                  <ListItemText
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: "bold" }}
                                    primary={company.organization.primaryName}
                                  />
                                </div>
                                <div>
                                  {company?.organization?.tickerSymbol && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Ticker - ${company?.organization?.tickerSymbol}`}
                                    />
                                  )}
                                  <ListItemText
                                    secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56", }}
                                    secondary={`Street - ${company?.organization?.primaryAddress?.streetAddress?.line1 || ''}`}
                                  />
                                  {company?.organization?.primaryAddress?.addressLocality?.name && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`City - ${company?.organization?.primaryAddress?.addressLocality?.name}`}
                                    />
                                  )}
                                  {company?.organization?.primaryAddress?.addressRegion?.name && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`State - ${company?.organization?.primaryAddress?.addressRegion?.name}`}
                                    />
                                  )}
                                  <ListItemText
                                    secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                    secondary={`Country - ${company?.organization?.primaryAddress?.addressCountry?.name || ''}`}
                                  />
                                  {company?.organization?.primaryAddress?.postalCode && (
                                    <ListItemText
                                      secondaryTypographyProps={{ fontSize: 12, color: "#1A2A56" }}
                                      secondary={`Zip Code - ${company?.organization?.primaryAddress?.postalCode}`}
                                    />
                                  )}
                                </div>
                              </ListItemButton>
                              {selectedCompanies.some((selected) => selected.organization.duns === company.organization.duns) ? (
                                <div style={{ display: "flex", gap: "5px", padding: "5px", flexDirection: "column", justifyContent: "center" }}>
                                  <Typography sx={{ fontSize: "14px" }}>
                                    Enter Requested Amount:
                                  </Typography>
                                  <TextField
                                    value={creditLimits['requestedCreditLimit']}
                                    onChange={(e) => handleRequestedCreditLimitChange(company, e.target.value)}
                                    sx={{
                                      '& .MuiInputBase-root': {
                                        height: '30px',
                                        border: '1px solid black',
                                        borderRadius: '4px',
                                      },
                                      '& .MuiInputLabel-root': {
                                        top: '-8px',
                                        fontSize: "12px"
                                      },
                                      '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                          borderColor: 'darkgrey',
                                        },
                                        '&:hover fieldset': {
                                          borderColor: 'black',
                                        },
                                        '&.Mui-focused fieldset': {
                                          borderColor: 'black',
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              ) : null}
                            </div>
                          );
                        })
                      )}
                    </div>
                    {
                      showLeftButton ? (<button
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: "-35px",
                          transform: 'translateY(-50%)',
                          zIndex: 1,
                        }}
                        onClick={scrollListLeft}
                      >
                        <img src={LeftIcon} alt="" />
                      </button>) : null
                    }

                    {
                      companySearchResults?.length > 3 ?
                        <button
                          style={{
                            position: 'absolute',
                            top: '50%',
                            right: "-30px",
                            transform: 'translateY(-50%)',
                            zIndex: 1,
                          }}
                          onClick={scrollListRight}
                        >
                          <img src={RightIcon} alt="" />
                        </button> : null
                    }

                    {
                      perplexityResponse?.length > 3 ?
                        <button
                          style={{
                            position: 'absolute',
                            top: '50%',
                            right: "-30px",
                            transform: 'translateY(-50%)',
                            zIndex: 1,
                          }}
                          onClick={scrollListRight}
                        >
                          <img src={RightIcon} alt="" />
                        </button> : null
                    }
                  </div>

                  <Box>
                    {(!companySearchResults || companySearchResults.length === 0) && (
                      <Button
                        fullWidth
                        onClick={() => {
                          setOpen(true);
                          setModalOpen(false);
                          setOpenAddCompanyModal(false);
                          if (typeof onClose === 'function') onClose();
                          setSearchOption("name");
                        }}
                        variant="contained"
                        sx={{ ...buttonStyle, width: "232px" }}
                      >
                        Add Company Manually
                      </Button>
                    )}
                  </Box>
                  {selectedCompanies.length ? (<div style={{ alignSelf: "start" }}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend" >Please Choose:</FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          value="Prospect"
                          control={<CustomCheckbox checked={selectedOption === "Prospect"} />}
                          label="Prospect"
                          sx={formControlLabelStyle}
                          onChange={() => handleChange("Prospect")}
                        />
                        <FormControlLabel
                          value="Existing Customer"
                          control={<CustomCheckbox checked={selectedOption === "Existing Customer"} />}
                          label="Existing Customer"
                          sx={formControlLabelStyle}
                          onChange={() => handleChange("Existing Customer")}
                        />
                      </FormGroup>
                    </FormControl>
                  </div>) : null}
                  <div style={{ margin: "20px 0 30px 0", textAlign: "center" }}>
                    <Button onClick={handleBack} style={backStyle}>Back</Button>
                    <Button
                      variant="contained"
                      sx={{
                        width: selectedOption === "Prospect" ? "200px" : "138px",
                        height: "36px",
                        marginLeft: "10px",
                        borderRadius: "8px",
                        backgroundColor: "#5186EC",
                        '&:disabled': {
                          backgroundColor: '#f0f0f0',
                        },
                        '&:hover': {
                          backgroundColor: '#5186EC',
                        },
                      }}
                      disabled={!selectedOption || isAddingCompany}
                      onClick={handleAddCompany}
                    >
                      {isAddingCompany ? "Adding..." : (selectedOption === "Prospect" ? "Add and Complete" : "Add")}
                    </Button>
                  </div>
                </div>)}
                {(activeStep === 3 || activeStep === 4) && (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                    <div style={{ margin: "20px 0 30px 0", textAlign: "center", paddingBottom: "30px" }}>
                      <div style={containerStyle}>
                        <Typography
                          sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "#2F3D63",
                          }}
                        >
                          Company added Successfully
                        </Typography>
                        <img src={CompletedIcon} alt="" style={{ marginLeft: "120px" }} width="45px" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Box>
          </div>
        </Modal>
      </div>
      <Dialog
        open={parentCompanyDailog}
        onClose={toggleAddCompanyManuallyModal}
      >
        <DialogTitle>{"Would you like to add this company without a parent company?"}</DialogTitle>
        <DialogContent>
          <Typography>
            Adding a company without a parent company will create a new record.
            Are you sure you want to proceed?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleYesClick} color="primary">
            Yes
          </Button>
          <Button onClick={handleNoClick} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Modal open={open} onClose={handleCloseClick} style={modalStyle}>
        <Box sx={{ ...style, maxWidth: 400, margin: 'auto', mt: 8, borderRadius: 4, p: 4, bgcolor: 'background.paper' }}>
          <Typography id="manual-modal-title" variant="h6" component="h2" sx={{ textAlign: "center", mb: 2, color: "#2F3D63", fontWeight: 700 }}>
            Add Company Manually
          </Typography>
          <Stack spacing={2}>
            <TextField
              id="companyName"
              label="Company Name *"
              variant="outlined"
              value={companyNameValue}
              onChange={handleCompanyNameChange}
              error={error}
              helperText={error ? errorTxt : ""}
              required
              fullWidth
            />
            <Autocomplete
              id="company-country-select"
              options={CountryISOCodes}
              getOptionLabel={(option) => option.name}
              value={CountryISOCodes.find(option => option["alpha-2"] === companyCountryValue) || null}
              onChange={(e, value) => setCompanyCountryValue(value ? value["alpha-2"] : "")}
              renderInput={(params) => <TextField {...params} label="Company Country *" required />}
              fullWidth
            />
            <TextField
              id="requestedCreditLimit"
              label="Requested Credit Limit"
              variant="outlined"
              value={requestedCreditLimit}
              onChange={e => setRequestedCreditLimit(e.target.value)}
              fullWidth
            />
            <FormControlLabel
              control={<Checkbox checked={isPublic} onChange={e => setIsPublic(e.target.checked)} color="primary" />}
              label="Is Company Public?"
            />
            <FormControlLabel
              control={<Checkbox checked={addParentConpany} onChange={e => {
                setAddParentCompany(e.target.checked);
              }} color="primary" />}
              label="Add a parent company?"
            />
            {addParentConpany && (
              <>
          <TextField
            id="parentCompanyName"
                  label="Parent Company Name *"
                  variant="outlined"
            value={parentCompanyName}
                  onChange={e => setParentCompanyName(e.target.value)}
                  required
            fullWidth
                  sx={{ mt: 1 }}
          />
              <Autocomplete
                  id="parent-company-country-select"
                options={CountryISOCodes}
                getOptionLabel={(option) => option.name}
                value={CountryISOCodes.find(option => option["alpha-2"] === parentCompanyCountry) || null}
                onChange={(e, value) => setParentCompanyCountry(value ? value["alpha-2"] : "")}
                  renderInput={(params) => <TextField {...params} label="Parent Company Country *" required />}
                  fullWidth
                  sx={{ mt: 1 }}
                />
                <FormControlLabel
                  control={<Checkbox checked={isParentCompanyPublic} onChange={e => setIsParentCompanyPublic(e.target.checked)} color="primary" />}
                  label="Is Parent Company Public?"
                  sx={{ mt: 1 }}
                />
                {isParentCompanyPublic && (
                  <TextField
                    id="parentCompanyTicker"
                    label="Parent Company Ticker *"
                    variant="outlined"
                    value={parentCompanyTicker}
                    onChange={e => setParentCompanyTicker(e.target.value)}
                    required
        fullWidth
                    sx={{ mt: 1 }}
                  />
                )}
              </>
            )}
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button variant="contained" color="primary" onClick={handleManualAddClick} disabled={isAddingCompany} sx={{ minWidth: 100, fontWeight: 700 }}>{isAddingCompany ? 'Adding…' : 'ADD'}</Button>
              <Button variant="contained" color="inherit" onClick={handleCloseClick} sx={{ minWidth: 100, fontWeight: 700 }}>CLOSE</Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      
      {/* Segment Selection Dialog */}
      <Dialog 
        open={showSegmentDialog} 
        onClose={() => setShowSegmentDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Select Segment</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Would you like to assign this company to a segment?
          </DialogContentText>
          <List sx={{ 
            width: '100%',
            bgcolor: 'background.paper',
            border: '1px solid #E9E9E9',
            borderRadius: '8px',
            maxHeight: '300px',
            overflowY: 'auto'
          }}>
            {segments.map((segment) => (
              <ListItem
                key={segment.id}
                disablePadding
                sx={{
                  borderBottom: '1px solid #E9E9E9',
                  '&:last-child': {
                    borderBottom: 'none'
                  }
                }}
              >
                <ListItemButton 
                  onClick={() => {
                    // Toggle selection - if already selected, unselect it
                    if (selectedSegmentForCompany?.id === segment.id) {
                      setSelectedSegmentForCompany(null);
                    } else {
                      setSelectedSegmentForCompany(segment);
                    }
                  }}
                  sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    py: 1
                  }}
                >
                  <Checkbox
                    checked={selectedSegmentForCompany?.id === segment.id}
                    onChange={() => {
                      // Toggle selection - if already selected, unselect it
                      if (selectedSegmentForCompany?.id === segment.id) {
                        setSelectedSegmentForCompany(null);
                      } else {
                        setSelectedSegmentForCompany(segment);
                      }
                    }}
                    sx={{
                      color: '#5186EC',
                      '&.Mui-checked': {
                        color: '#5186EC',
                      },
                    }}
                  />
                  <Box sx={{ ml: 1 }}>
                    <Typography variant="body1">{segment.name}</Typography>
                    {segment.description && (
                      <Typography variant="caption" color="textSecondary">
                        {segment.description}
                      </Typography>
                    )}
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            onClick={() => {
              setSelectedSegmentForCompany(null);
              setSkipSegmentSelection(true);
              setShowSegmentDialog(false);
            }}
            sx={{ 
              width: '138px',
              height: '36px',
              border: '1px solid #5186EC',
              borderRadius: '8px',
              color: '#5186EC'
            }}
          >
            Skip
          </Button>
          <Button 
            onClick={() => {
              setShowSegmentDialog(false);
              if (addMode === "search") {
                handleAddCompany();
              } else {
                handleManualAddClick();
              }
            }}
            variant="contained"
            disabled={!selectedSegmentForCompany}
            sx={{ 
              width: '138px',
              height: '36px',
              borderRadius: '8px',
              backgroundColor: '#5186EC',
              '&:hover': {
                backgroundColor: '#5186EC'
              }
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default CreateCompanyModal;
